define(["require", "exports", "tslib", "mobx", "../EntityBase", "../EntityValidationState", "../../utils/EntityUtil", "../entity/SrCrParcel", "../entity/SrCrDoc", "../entity/SrCrUsageCond", "../../store/UserStore", "../domain", "./SrCrApproval"], function (require, exports, tslib_1, mobx_1, EntityBase_1, EntityValidationState_1, EntityUtil_1, SrCrParcel_1, SrCrDoc_1, SrCrUsageCond_1, UserStore_1, domain_1, SrCrApproval_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.SrCr = void 0;
    class SrCr extends EntityBase_1.Entity {
        constructor(entity = null, parent = null) {
            super();
            Object.defineProperty(this, "ApplicationId", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "ApplicationIdError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AncestorId", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AncestorIdError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "SystemState", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "SystemStateError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "RefId", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "RefIdError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "Lga", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "LgaError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "LgaCode", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "LgaCodeError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "ExpiryDate", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "ExpiryDateError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "ChangeDesc", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "ChangeDescError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "ChangeType", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "ChangeTypeError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "ChangeStatus", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "ChangeStatusError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "ChangeStatusReq", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "ChangeStatusReqError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "ChangeStatusPrev", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "ChangeStatusPrevError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "NewSrId", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "NewSrIdError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "NewSrSegment", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "NewSrSegmentError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "NewStatus", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "NewStatusError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "NewClassification", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "NewClassificationError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "CertDate", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "CertDateError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "CertDesc", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "CertDescError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AuditCreateUser", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AuditCreateUserError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AuditCreateDate", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AuditCreateDateError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AuditEditUser", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AuditEditUserError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AuditEditDate", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AuditEditDateError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AuditApprovalUser", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AuditApprovalUserError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AuditApprovalDate", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AuditApprovalDateError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AuditApprovalComment", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AuditApprovalCommentError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "SrCrParcel", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "SelectedSrCrParcel", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "SrCrParcelError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "SrCrDoc", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "SelectedSrCrDoc", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "SrCrDocError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "SrCrUsageCond", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "SelectedSrCrUsageCond", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "SrCrUsageCondError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "SrCrApplication", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "Approval", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            (0, mobx_1.makeObservable)(this);
            this.init(entity, parent, SrCr.ObservableFields);
        }
        onCreate(parent) {
            this.Id = (0, EntityUtil_1.id)();
            this.SrCrApplication = parent;
            this.ApplicationId = parent.Id;
            this.PersistanceState = EntityBase_1.PersistanceStates.NEW_RECORD;
            this.SecurityAccessLevel = EntityBase_1.EntitySecurityAccessLevels.READ_WRITE;
            this.SrCrParcel = [];
            this.SrCrDoc = [];
            this.SrCrUsageCond = [];
        }
        onRead(entity, parent) {
            this.SrCrApplication = parent;
            this.SrCrParcel = [];
            this.SrCrDoc = [];
            this.SrCrUsageCond = [];
            this.merge(entity);
        }
        merge(entity) {
            let a = this;
            let b = entity;
            if (!a || !b)
                throw new Error(`${this.constructor.name}.merge() expected a and b to be defined`);
            a.ObjectId = b.ObjectId;
            a.Id = (0, EntityUtil_1.toInt)(entity.Id);
            a.ApplicationId = (0, EntityUtil_1.toInt)(entity.ApplicationId);
            a.AncestorId = (0, EntityUtil_1.toInt)(entity.AncestorId);
            a.SystemState = (0, EntityUtil_1.toInt)(entity.SystemState);
            a.RefId = b.RefId;
            a.Lga = b.Lga;
            a.LgaCode = b.LgaCode;
            a.ExpiryDate = b.ExpiryDate;
            a.ChangeDesc = b.ChangeDesc;
            a.ChangeType = (0, EntityUtil_1.toInt)(entity.ChangeType);
            a.ChangeStatus = b.ChangeStatus;
            a.ChangeStatusReq = b.ChangeStatusReq;
            a.ChangeStatusPrev = b.ChangeStatusPrev;
            a.NewSrId = b.NewSrId;
            a.NewSrSegment = b.NewSrSegment;
            a.NewStatus = b.NewStatus;
            a.NewClassification = b.NewClassification;
            a.CertDate = b.CertDate;
            a.CertDesc = b.CertDesc;
            a.AuditCreateUser = b.AuditCreateUser;
            a.AuditCreateDate = b.AuditCreateDate;
            a.AuditEditUser = b.AuditEditUser;
            a.AuditEditDate = b.AuditEditDate;
            a.AuditApprovalUser = b.AuditApprovalUser;
            a.AuditApprovalDate = b.AuditApprovalDate;
            a.AuditApprovalComment = b.AuditApprovalComment;
            a.SrCrParcel = this.mergeArray(a.SrCrParcel, b.SrCrParcel, SrCrParcel_1.SrCrParcel);
            a.SelectedSrCrParcel = a.SelectedSrCrParcel && a.SrCrParcel.find(x => x.Id == a.SelectedSrCrParcel.Id) ? a.SelectedSrCrParcel : null;
            a.SrCrDoc = this.mergeArray(a.SrCrDoc, b.SrCrDoc, SrCrDoc_1.SrCrDoc);
            a.SelectedSrCrDoc = a.SelectedSrCrDoc && a.SrCrDoc.find(x => x.Id == a.SelectedSrCrDoc.Id) ? a.SelectedSrCrDoc : null;
            a.SrCrUsageCond = this.mergeArray(a.SrCrUsageCond, b.SrCrUsageCond, SrCrUsageCond_1.SrCrUsageCond);
            a.SelectedSrCrUsageCond = a.SelectedSrCrUsageCond && a.SrCrUsageCond.find(x => x.Id == a.SelectedSrCrUsageCond.Id) ? a.SelectedSrCrUsageCond : null;
            a.PersistanceState = b.PersistanceState;
            a.SecurityAccessLevel = b.SecurityAccessLevel;
            this.postMerge();
        }
        postMerge() {
            this.Approval && this.Approval.evaluateStatus();
        }
        onReady() {
            this.Approval = new SrCrApproval_1.SrCrApproval(this);
        }
        hasChanges(recurseChildren = true) {
            let hasChanges = false;
            this.walk((entity) => {
                if (!hasChanges && recurseChildren && entity != null) {
                    hasChanges = hasChanges || entity.hasChanges();
                }
            }, { skipRoot: true });
            hasChanges = hasChanges || (this.PersistanceState != EntityBase_1.PersistanceStates.EXISTING_UNMODIFIED);
            return hasChanges;
        }
        validate(recurseChildren = true) {
            let validationState = new EntityValidationState_1.EntityValidationState(this.Id, SrCr.AliasName);
            this.reset();
            if (!this.IsMarkedForDeletion && this.IsActive && this.Approval.IsPendingOrCertified) {
                this._validate(validationState, recurseChildren);
            }
            return validationState;
        }
        _validate(validationState, recurseChildren = true) {
            if (this.PersistanceState != EntityBase_1.PersistanceStates.MARKED_FOR_DELETION) {
                if (recurseChildren) {
                    this.walk((entity) => { validationState.add(entity.validate()); }, { skipRoot: true });
                }
                this.validateReqNumber(validationState, "Id", "ID");
                this.validateReqNumber(validationState, "ApplicationId", "Application ID");
                this.validateReqString(validationState, "RefId", "Reference Id");
                this.validateReqString(validationState, "Lga", "LGA");
                this.validateReqString(validationState, "LgaCode", "LGA Code");
                this.validateReqNumber(validationState, "ChangeType", "Change Request Type");
                this.validateReqString(validationState, "ChangeStatus", "Change Request Status (Actual)");
                this.validateReqString(validationState, "AuditCreateUser", "Requested By (Initial)");
                this.validateReqDate(validationState, "AuditCreateDate", "Requested Date (Initial)");
            }
        }
        dispose() {
            this.walk((entity) => { super.dispose(); }, { leading: true });
        }
        walk(func, args = {}) {
            let { leading, skipRoot } = args;
            if (!skipRoot && leading) {
                func(this);
            }
            if (this.SrCrParcel) {
                for (let x of this.SrCrParcel) {
                    x.walk(func, { leading });
                }
            }
            if (this.SrCrDoc) {
                for (let x of this.SrCrDoc) {
                    x.walk(func, { leading });
                }
            }
            if (this.SrCrUsageCond) {
                for (let x of this.SrCrUsageCond) {
                    x.walk(func, { leading });
                }
            }
            if (!skipRoot && !leading) {
                func(this);
            }
        }
        toJson() {
            return {
                ObjectId: this.ObjectId,
                Id: this.Id,
                ApplicationId: this.ApplicationId,
                AncestorId: this.AncestorId,
                SystemState: this.SystemState,
                RefId: this.RefId,
                Lga: this.Lga,
                LgaCode: this.LgaCode,
                ExpiryDate: this.ExpiryDate,
                ChangeDesc: this.ChangeDesc,
                ChangeType: this.ChangeType,
                ChangeStatus: this.ChangeStatus,
                ChangeStatusReq: this.ChangeStatusReq,
                ChangeStatusPrev: this.ChangeStatusPrev,
                NewSrId: this.NewSrId,
                NewSrSegment: this.NewSrSegment,
                NewStatus: this.NewStatus,
                NewClassification: this.NewClassification,
                CertDate: this.CertDate,
                CertDesc: this.CertDesc,
                AuditCreateUser: this.AuditCreateUser,
                AuditCreateDate: this.AuditCreateDate,
                AuditEditUser: this.AuditEditUser,
                AuditEditDate: this.AuditEditDate,
                AuditApprovalUser: this.AuditApprovalUser,
                AuditApprovalDate: this.AuditApprovalDate,
                AuditApprovalComment: this.AuditApprovalComment,
                SrCrParcel: this.SrCrParcel.map(x => x.toJson()),
                SrCrDoc: this.SrCrDoc.map(x => x.toJson()),
                SrCrUsageCond: this.SrCrUsageCond.map(x => x.toJson()),
                PersistanceState: this.PersistanceState,
                SecurityAccessLevel: this.SecurityAccessLevel
            };
        }
        get CanAmend() {
            let pass = this.IsActive
                && this.IsUserPriviledgedToEdit
                && this.IsAmendmentModeActive;
            if (!pass) {
                return false;
            }
            if ((0, UserStore_1.isUserStateGovAdminOfficer)()) {
                return this.ChangeStatus != domain_1.SrCrStatusDomain.Certified &&
                    this.ChangeStatus != domain_1.SrCrStatusDomain.Cancelled;
            }
            else {
                return this.ChangeStatus == domain_1.SrCrStatusDomain.Submitted ||
                    this.ChangeStatus == domain_1.SrCrStatusDomain.SubmissionRejected ||
                    this.ChangeStatus == domain_1.SrCrStatusDomain.ConsultationRejected ||
                    this.ChangeStatus == domain_1.SrCrStatusDomain.ReleaseForConsultationRejected;
            }
        }
        get IsUserPriviledgedToEdit() {
            return this.SecurityAccessLevel == EntityBase_1.EntitySecurityAccessLevels.READ_WRITE;
        }
        get IsAmendmentModeActive() {
            return this.ChangeStatus != domain_1.SrCrStatusDomain.Draft ? true : false;
        }
        get IsReadOnly() {
            let readonly = !this.IsUserPriviledgedToEdit || this.SystemState == domain_1.SrCrSysStatusDomain.Archived;
            let canEdit = true;
            if ((0, UserStore_1.isUserStateGovAdminOfficer)()) {
                canEdit = !readonly && this.ChangeStatus != domain_1.SrCrStatusDomain.Certified && this.ChangeStatus != domain_1.SrCrStatusDomain.Cancelled;
            }
            else {
                canEdit = !readonly && this.ChangeStatus == domain_1.SrCrStatusDomain.Draft;
            }
            return !canEdit;
        }
        get IsActive() {
            return this.SystemState == domain_1.SrCrSysStatusDomain.Active;
        }
        get StatusValue() {
            var _a;
            let k = this.ChangeStatusReq ? this.ChangeStatusReq : this.ChangeStatus;
            let v = (_a = domain_1.SrCrStatusDomain.findByKey(k)) === null || _a === void 0 ? void 0 : _a.value;
            return this.ChangeStatusReq ? `${v}*` : v;
        }
        get NewlyIssuedSrIds() {
            if (this.ChangeType == domain_1.SrCrTypeDomain.AddSrnParcel) {
                const hasReserve = this.SrCrParcel.some(x => x.OrigType == domain_1.SrTypeDomain.Reserve);
                const hasNonReserve = this.SrCrParcel.some(x => x.OrigType != domain_1.SrTypeDomain.Reserve);
                const output = [];
                if (hasReserve) {
                    output.push("Reserve".toUpperCase());
                }
                if (hasNonReserve) {
                    output.push(this.NewSrId);
                }
                return output.join(", ");
            }
            return "";
        }
    }
    exports.SrCr = SrCr;
    Object.defineProperty(SrCr, "Name", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "SrCr"
    });
    Object.defineProperty(SrCr, "AliasName", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "SRN Change Request"
    });
    Object.defineProperty(SrCr, "ObservableFields", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: ["ObjectId", "Id", "ApplicationId", "AncestorId", "SystemState", "RefId", "Lga", "LgaCode", "ExpiryDate", "ChangeDesc", "ChangeType", "ChangeStatus", "ChangeStatusReq", "ChangeStatusPrev", "NewSrId", "NewSrSegment", "NewStatus", "NewClassification", "CertDate", "CertDesc", "AuditCreateUser", "AuditCreateDate", "AuditEditUser", "AuditEditDate", "AuditApprovalUser", "AuditApprovalDate", "AuditApprovalComment"]
    });
    Object.defineProperty(SrCr, "ApplicationIdReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(SrCr, "AncestorIdReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(SrCr, "SystemStateDomain", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(SrCr, "SystemStateReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(SrCr, "RefIdLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 30
    });
    Object.defineProperty(SrCr, "RefIdReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(SrCr, "LgaLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 255
    });
    Object.defineProperty(SrCr, "LgaReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(SrCr, "LgaCodeLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 10
    });
    Object.defineProperty(SrCr, "LgaCodeReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(SrCr, "ExpiryDateReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(SrCr, "ChangeDescLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 255
    });
    Object.defineProperty(SrCr, "ChangeDescReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(SrCr, "ChangeTypeDomain", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(SrCr, "ChangeTypeReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(SrCr, "ChangeStatusLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 6
    });
    Object.defineProperty(SrCr, "ChangeStatusDomain", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(SrCr, "ChangeStatusReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(SrCr, "ChangeStatusReqLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 6
    });
    Object.defineProperty(SrCr, "ChangeStatusReqDomain", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(SrCr, "ChangeStatusReqReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(SrCr, "ChangeStatusPrevLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 6
    });
    Object.defineProperty(SrCr, "ChangeStatusPrevDomain", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(SrCr, "ChangeStatusPrevReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(SrCr, "NewSrIdLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 64
    });
    Object.defineProperty(SrCr, "NewSrIdTooltip", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "Enter the new Stock Route identifier (this will apply to all parcels)"
    });
    Object.defineProperty(SrCr, "NewSrIdReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(SrCr, "NewSrSegmentLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 3
    });
    Object.defineProperty(SrCr, "NewSrSegmentTooltip", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "Enter the new Stock Route segment identifier (this will apply to all parcels)"
    });
    Object.defineProperty(SrCr, "NewSrSegmentReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(SrCr, "NewStatusLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 20
    });
    Object.defineProperty(SrCr, "NewStatusTooltip", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "Enter the new or modified Stock Route status (this will apply to all parcels)"
    });
    Object.defineProperty(SrCr, "NewStatusDomain", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(SrCr, "NewStatusReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(SrCr, "NewClassificationLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 20
    });
    Object.defineProperty(SrCr, "NewClassificationTooltip", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "Enter the new or modified Stock Route classification (this will apply to all parcels)"
    });
    Object.defineProperty(SrCr, "NewClassificationDomain", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(SrCr, "NewClassificationReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(SrCr, "CertDateReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(SrCr, "CertDescLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 255
    });
    Object.defineProperty(SrCr, "CertDescReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(SrCr, "AuditCreateUserLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 255
    });
    Object.defineProperty(SrCr, "AuditCreateUserReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(SrCr, "AuditCreateDateReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(SrCr, "AuditEditUserLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 255
    });
    Object.defineProperty(SrCr, "AuditEditUserReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(SrCr, "AuditEditDateReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(SrCr, "AuditApprovalUserLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 255
    });
    Object.defineProperty(SrCr, "AuditApprovalUserReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(SrCr, "AuditApprovalDateReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(SrCr, "AuditApprovalCommentLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 255
    });
    Object.defineProperty(SrCr, "AuditApprovalCommentReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    tslib_1.__decorate([
        mobx_1.observable
    ], SrCr.prototype, "ApplicationId", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], SrCr.prototype, "ApplicationIdError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], SrCr.prototype, "AncestorId", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], SrCr.prototype, "AncestorIdError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], SrCr.prototype, "SystemState", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], SrCr.prototype, "SystemStateError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], SrCr.prototype, "RefId", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], SrCr.prototype, "RefIdError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], SrCr.prototype, "Lga", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], SrCr.prototype, "LgaError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], SrCr.prototype, "LgaCode", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], SrCr.prototype, "LgaCodeError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], SrCr.prototype, "ExpiryDate", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], SrCr.prototype, "ExpiryDateError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], SrCr.prototype, "ChangeDesc", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], SrCr.prototype, "ChangeDescError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], SrCr.prototype, "ChangeType", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], SrCr.prototype, "ChangeTypeError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], SrCr.prototype, "ChangeStatus", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], SrCr.prototype, "ChangeStatusError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], SrCr.prototype, "ChangeStatusReq", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], SrCr.prototype, "ChangeStatusReqError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], SrCr.prototype, "ChangeStatusPrev", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], SrCr.prototype, "ChangeStatusPrevError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], SrCr.prototype, "NewSrId", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], SrCr.prototype, "NewSrIdError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], SrCr.prototype, "NewSrSegment", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], SrCr.prototype, "NewSrSegmentError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], SrCr.prototype, "NewStatus", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], SrCr.prototype, "NewStatusError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], SrCr.prototype, "NewClassification", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], SrCr.prototype, "NewClassificationError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], SrCr.prototype, "CertDate", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], SrCr.prototype, "CertDateError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], SrCr.prototype, "CertDesc", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], SrCr.prototype, "CertDescError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], SrCr.prototype, "AuditCreateUser", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], SrCr.prototype, "AuditCreateUserError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], SrCr.prototype, "AuditCreateDate", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], SrCr.prototype, "AuditCreateDateError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], SrCr.prototype, "AuditEditUser", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], SrCr.prototype, "AuditEditUserError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], SrCr.prototype, "AuditEditDate", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], SrCr.prototype, "AuditEditDateError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], SrCr.prototype, "AuditApprovalUser", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], SrCr.prototype, "AuditApprovalUserError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], SrCr.prototype, "AuditApprovalDate", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], SrCr.prototype, "AuditApprovalDateError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], SrCr.prototype, "AuditApprovalComment", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], SrCr.prototype, "AuditApprovalCommentError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], SrCr.prototype, "SrCrParcel", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], SrCr.prototype, "SelectedSrCrParcel", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], SrCr.prototype, "SrCrParcelError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], SrCr.prototype, "SrCrDoc", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], SrCr.prototype, "SelectedSrCrDoc", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], SrCr.prototype, "SrCrDocError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], SrCr.prototype, "SrCrUsageCond", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], SrCr.prototype, "SelectedSrCrUsageCond", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], SrCr.prototype, "SrCrUsageCondError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], SrCr.prototype, "SrCrApplication", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], SrCr.prototype, "onCreate", null);
    tslib_1.__decorate([
        mobx_1.action
    ], SrCr.prototype, "onRead", null);
    tslib_1.__decorate([
        mobx_1.action
    ], SrCr.prototype, "merge", null);
    tslib_1.__decorate([
        mobx_1.observable
    ], SrCr.prototype, "Approval", void 0);
    tslib_1.__decorate([
        mobx_1.computed
    ], SrCr.prototype, "CanAmend", null);
    tslib_1.__decorate([
        mobx_1.computed
    ], SrCr.prototype, "IsUserPriviledgedToEdit", null);
    tslib_1.__decorate([
        mobx_1.computed
    ], SrCr.prototype, "IsAmendmentModeActive", null);
    tslib_1.__decorate([
        mobx_1.computed
    ], SrCr.prototype, "IsReadOnly", null);
    tslib_1.__decorate([
        mobx_1.computed
    ], SrCr.prototype, "IsActive", null);
    tslib_1.__decorate([
        mobx_1.computed
    ], SrCr.prototype, "StatusValue", null);
    tslib_1.__decorate([
        mobx_1.computed
    ], SrCr.prototype, "NewlyIssuedSrIds", null);
});
